<template lang="html">
  <div class="wcc overlay">
    <div class="wcc close" v-hammer:tap="hideOverlay">
      <font-awesome-icon :icon="['fa', 'times']" />
    </div>
    <div class="wcc content">
      <img src="@/assets/m_white.svg" alt="Fee Calculator Logo">
      <p>Install this application for quick, easy access and offline use.</p>
      <p>Just tap the <img src="@/assets/ios-action.png" alt="ios action button"> and "Add to Homescreen" (Safari only)</p>
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      hideOverlay() {
        this.$store.dispatch('addToHomescreen/hideOverlay')
      }
    }
  }
</script>
<style lang="scss">
.wcc.overlay {
  background-color: $blue-mr;
  position: fixed;
  bottom: $spacing/2;
  margin: auto;
  width: 100%;
  max-width: $max-width;
  z-index: 98;
  .wcc.close {
    color: white;
    position: absolute;
    right: 0;
    padding: $spacing/1.5;
    top: -.18em;
    font-size: 1.5em;
    cursor: pointer;
    z-index: 1;
  }
  .wcc.content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: white;
    text-align: center;
    > img {
      width: 20%;
      max-width: 100px;
      margin-bottom: $spacing/2;
    }
    > p {
      margin-top: $spacing/2;
      margin-bottom: 0;
      img {
        height: 1.25em;
        width: auto;
      }
    }
  }
  &:after {
    content: '';
    position: absolute;
    left: calc(50% - #{$spacing/2});
    top: 100%;
    width: 0;
    height: 0;
    border-left: $spacing/2 solid transparent;
    border-right: $spacing/2 solid transparent;
    border-top: $spacing/2 solid $blue-mr;
  }
  
}
</style>